<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">编辑工作经历</span>
      </p>
      <p style="padding-right: 2rem;color: #FFFFFF " @click="delWorker">删除</p>
    </header>
    <div class="personalMain" >
      <!--<div class="inforName">-->
        <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
          <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
          <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
       <p class="inforNameTop">公司名称{{$route.params.id}}</p>
       <p v-if="data"> <input class="inforNameInput" type="text" v-model="data.name"  ></p>
      </div>
      <div class="inforName" >
        <p class="inforNameTop">公司行业</p>
        <p v-if="data"><input class="inforNameInput" type="text" v-model="data.industry" ></p>
      </div>
      <div class="inforName" >
        <p class="inforNameTop">在职时间</p>
        <p v-if="data" style="display: flex">
          <input class="inforTime" type="text" v-model="data.entrytime" >
          <span>--</span>
          <input class="inforTime" type="text" v-model="data.resigntime" ></p>
      </div>
      <div class="inforName" >
        <p class="inforNameTop">职位类型</p>
        <p v-if="data"><input class="inforNameInput" type="text" v-model="data.positiontype" ></p>
      </div>
      <div class="inforName" >
        <p class="inforNameTop">职位名称</p>
        <p v-if="data"><input class="inforNameInput" type="text" v-model="data.positionname" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所属部门</p>
        <p v-if="data"><input class="inforNameInput" type="text" v-model="data.department" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位名称</p>
        <p v-if="data">
          <textarea style="width: 100%;height: 5rem" v-model="data.workdescription">{{data.workdescription}}</textarea>
        </p>
      </div>
      <div class="inforName">
        <van-button style="width: 100%;margin: 0 auto" type="primary" @click="saveWorker()">保存</van-button>

      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        data:{
          name:'',
          industry:"",
          entrytime:"",
          resigntime:"",
          positiontype:'',
          positionname:"",
          department:"",
          workdescription:''
        }
      }
    },
    mounted(){
      this.getWorker()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getWorker(){
        console.log(this.$route.params.id)
        this.$api.getWork({'id':this.$route.params.id}).then(res=>{
          console.log(res)
          this.data=res.data
          console.log(this.data)
        }).catch(err=>{

        })
      },
      saveWorker(){
        console.log(this.data)
        this.$api.saveWork({
          "data[name]": this.data.name,
        "data[industry]": this.data.industry,
        "data[entrytime]": this.data.entrytime,
        "data[resigntime]": this.data.resigntime,
        "data[positiontype]": this.data.positiontype,
        "data[positionname]": this.data.positionname,
        "data[department]": this.data.department,
        "data[workdescription]":this.data.workdescription,
          'id':this.$route.params.id
          }).then(res=>{
         this.$router.push("/editResume")
        }).catch(err=>{
        })
      },
      delWorker(){
        console.log(this.data)
        this.$api.delWork({'id':this.$route.params.id}).then(res=>{
          this.$router.push("/editResume")
        }).catch(err=>{
        })
      }
    },


  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
   border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
    /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/editWork.vue